import { computed, inject, Injectable, signal } from '@angular/core';
import { PackLimitationsService } from 'src/app/shared/services/pack-limitations.service';

@Injectable({
  providedIn: 'root',
})
export class TableSettingsService {
  packLimitationService = inject(PackLimitationsService);

  private readonly COLUMNS_STORAGE_KEY = 'travelBoard.tableView.hiddenColumns';

  readonly toggleableColumns: { key: string; labelKey: string }[] = [
    { key: 'fileName', labelKey: 'travelBoards.fileName' },
    { key: 'createdAt', labelKey: 'travelBoards.createdAt' },
    { key: 'countryName', labelKey: 'travelBoards.country' },
    { key: 'companyClients', labelKey: 'travelBoards.client' },
    { key: 'days', labelKey: 'travelBoards.days' },
    { key: 'travellers', labelKey: 'travelBoards.travellers' },
    { key: 'totalImpact', labelKey: 'travelBoards.emissionsShort' },
    { key: 'ecoScore', labelKey: 'travelBoards.ecoScore' },
  ];

  hiddenColumns = signal<Set<string>>(this.loadHiddenColumnsFromStorage());

  emptyColspan = computed(() => {
    const hidden = this.hiddenColumns();
    let count = 3; // checkbox + title + actions
    for (const col of this.toggleableColumns) {
      if (
        col.key === 'companyClients' &&
        !this.packLimitationService.canFilterClient()
      ) {
        continue;
      }
      if (!hidden.has(col.key)) count++;
    }
    return count;
  });

  private loadHiddenColumnsFromStorage(): Set<string> {
    const saved = localStorage.getItem(this.COLUMNS_STORAGE_KEY);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          return new Set(parsed);
        }
      } catch {
        // fallback to defaults
      }
    }
    return new Set();
  }

  isColumnVisible(key: string): boolean {
    return !this.hiddenColumns().has(key);
  }

  toggleColumn(key: string, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    const next = new Set(this.hiddenColumns());
    if (checked) next.delete(key);
    else next.add(key);
    this.hiddenColumns.set(next);
    localStorage.setItem(
      this.COLUMNS_STORAGE_KEY,
      JSON.stringify(Array.from(next)),
    );
  }
}
